import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { PostBaseBusinessForecastForReceiptAdapter } from '../adapter/postBaseBusinessForecastForReceiptAdapter';

/**
 * 関連取引を受領用内示に登録するUseCase
 */
export class AddBaseBusinessForecastForReceiptUseCase {
  private repository: IForecastForReceiptRepository;

  /**
   * @param repository - 受領用内示情報の永続化の責務を負うクラス
   */
  constructor(repository: IForecastForReceiptRepository) {
    this.repository = repository;
  }

  /**
   * 関連取引を受領用内示に登録する
   * @param baseBusinessIds - 関連取引ID
   * @param forecastForReceiptId - 受領用内示ID
   */
  public Execute = async (baseBusinessIds: string[], forecastForReceiptId: string): Promise<INetworkResult<void, Error>> => {
    try {
      const request = PostBaseBusinessForecastForReceiptAdapter.adaptForRequest(baseBusinessIds, forecastForReceiptId);
      const result = await this.repository.postBaseBusinessToForecastForReceipt(request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('追加に失敗しました'),
        },
      };
    }
  };
}
